import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss'
})
export class AvatarComponent {

  @Input() imageSrc: string | ArrayBuffer | null = '';
  @Input() name: string = '';
  @Input() size: number = 48;

  getDimensions(): { [key: string]: string } {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`
    };
  }

  getFontSize(): { [key: string]: string } {
    return { 'font-size': `${this.size * 0.38}px` };
  }

  getInitials(): string {
    const tokens = this.name.split(' ').filter(token => /^[a-zA-Z]+$/.test(token));
    if (tokens.length === 0) {
      return '';
    }

    let result = '';

    if (tokens[0]) {
      result += tokens[0][0];
    }

    if (tokens.length > 1) {
      const lastToken = tokens[tokens.length - 1];
      if (lastToken !== tokens[0]) {
        result += lastToken[0];
      }
    }

    return result.toUpperCase();
  }
}